import React, { useEffect } from 'react';
import { useState, Downgraded, createState } from '@hookstate/core';
import { useParams, useHistory, generatePath } from 'react-router-dom';
import RouteConstants from '../../constants/routeConstants';
import DraftRegistration from '../../pages/DraftRegistration/DraftRegistration';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import { useEventState } from '../../stores/eventStore';
import { NO_ACCESS_PERMISSION, FULL_PERMISSION, VIEW_PERMISSION } from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import Title from '../../sharedcomponents/title/title';
import { AppBar, Box, Button, Grid, Typography } from '@mui/material';
import AppConstants from '../../constants/appConstants';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import AddGuest from '../../pages/DraftRegistration/AddGuest';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import { makeStyles } from '@mui/styles';
import IconPencil from '../../assets/images/Icon_Pencil.svg';
import trash from '../../assets/images/trash.svg';

const appBarStyle = {
    mb: 1,
    boxShadow: 'none',
    pt: 1,
    pb: 1,
    pl: 1,
    borderTop: '1px solid #D7D7D7',
    borderBottom: '1px solid #D7D7D7',
    backgroundColor: '#F8F8F8',
};
const greenRoomState = createState({
    guestList: [],
});
const useStyles = makeStyles({
    mobileLogo: {
        height: 42,
    },
    sedanBlack: {
        height: 18,
        width: 36,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
});
const CreateGreenRoom = (props) => {
    const eventState = useEventState();
    const classes = useStyles();
    const state = useState(greenRoomState);
    const greenRoomGuest = useState(2);
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const [participant, setParticipant] = React.useState(null);
    const [participantList, setParticipantList] = React.useState(null);
    const history = useHistory();
    const [modPermission, setModPermission] = React.useState(null);
    const guestList = useState(null);
    const changeParticipant = async (participant) => {
        setParticipant(participant);
    }
    const openGuestDialog = useState(false);
    const stateGuestObj = useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const moduleIndex = useState(-1);
    const isPreDraftPicture = useState(false);
    const getModuleDetailsData = (eventDetail) => {
        if (eventDetail?.moduleDetails) {
            const index = eventDetail.moduleDetails.findIndex((element) => {
                if (element.moduleName === 'GreenRoom') {
                    return true;
                }
            });
            //setShowAgentProParticipant(eventDetail.moduleDetails[index].showAgentProDayParticipant)
            if (!Helper.isAdminUser(userInfo)) {
                moduleIndex.set(index);
            }
        }
    };
    useEffect(() => {
        if (eventState && eventState.eventDetail.get() != null) {
            if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo) || Helper.isEventAdmin(userInfo)) {
                setModPermission(FULL_PERMISSION)
            }
            else if (!Helper.isAdminUser(userInfo)) {
                const permissions = eventState.permissions.attach(Downgraded).get();
                if (permissions && permissions.length > 0) {
                    setModPermission(Helper.getModuleAccessPermission(permissions, 'GREENROOM'));
                }
            }
        }
    }, [eventState])
    useEffect(() => {
        if (
            history.location &&
            typeof history.location.state !== 'undefined'
        ) {
            // if (history.location.state.adminUser) {
            //     setAsAdmin(history.location.state.adminUser);
            // }
            setParticipantList(history.location.state.participantList);
        }
        getModuleDetailsData(eventState.eventDetail)
    }, [])
    const handleAddGuestList = () => {
        openGuestDialog.set(true);
    };
    const handleAddGuestClose = () => {
        openGuestDialog.set(false);
        stateGuestObj.set(null);
    };
    const handleGuestAction = (name, relationship, i) => { 
        const values = [...state.attach(Downgraded).get().guestList];
        if (!stateGuestObj.get() && values.length > Number(greenRoomGuest.get())) {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Already added ' + Number(greenRoomGuest.get()) + ' guests for Greenroom',
            });
        } else {
            if (i >= 0) {
                values[i].name = name;

                values[i].relationship = relationship;
                state.guestList.set(values);
            } else {
                values.push({
                    name: name,
                    relationship: relationship,
                });

                state.guestList.set(values);
            }
            stateGuestObj.set(null);
            openGuestDialog.set(false);
            // handleDisableBtn();
        }
        // setDisableBtn(false)
    };
    const handleGuestEditData = (name, relationship, id) => {
        openGuestDialog.set(true);
        stateGuestObj.set({
            name: name,
            relationship: relationship,
            guestID: id,
        });
    };
    const handleRemoveGuest = (index) => {
        const values = guestList.attach(Downgraded).get();
        values.splice(index, 1);
        guestList.set(values);
    };

    return (
        <Box
            sx={{
                width: '100%'
            }}
        >
            <Box sx={{ ml: 2, mt: 2 }}>
                {' '}
                <Title title={Helper.getModuleName(eventInfo ? eventInfo.moduleDetails : [],
                    AppConstants.EVENT_MODULES.GREENROOM)} header={true} />
                {moduleIndex.get() >= 0 &&
                    eventState.eventDetail !== null &&
                    eventState.eventDetail.moduleDetails[
                        moduleIndex.get()
                    ].details != null ? (
                    <DetailsComponent
                        data={
                            eventState.eventDetail.moduleDetails[
                                moduleIndex.get()
                            ].details
                        }
                    />
                ) : null}
            </Box>
            <Box
                className="contentBox">
                <Box component="div">
                    <Box sx={{ width: '100%' }}>
                        <Grid
                            container
                            rowSpacing={2}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item container>
                                <Grid item md={4}></Grid>
                                <Grid item xs={12} md={4}>
                                    <ParticipantAutoList
                                        disableParticipant={
                                            // props.data && props.data
                                            //     ? true
                                            //     : false
                                            false
                                        }
                                        participant={participant}
                                        setParticipant={changeParticipant}
                                        participantList={participantList}
                                        modPermission={modPermission}
                                    />
                                </Grid>
                                <Grid item md={4}></Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
                <Box>
                    <Grid sx={{ padding: '16px 0', mt: 2 }}>
                        <Grid
                            container
                            rowSpacing={2}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <AppBar
                                position="static"
                                color="default"
                                sx={appBarStyle}>
                                <div
                                    style={{
                                        justifyContent: 'space-between',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'baseline',
                                    }}>
                                    <Title
                                        title={'Green Room Table'}
                                        // addicon="land"
                                        sx={{
                                            ml: 1,
                                        }}
                                    />
                                    <Button
                                        variant="contained"
                                        size="small"
                                        disabled={ 
                                                state.guestList.length ===
                                                greenRoomGuest.get() + 1 ||
                                                eventInfo.readonlyOrHide === 1
                                                ? eventRole !==
                                                    AppConstants
                                                        .EVENT_ROLES[0]
                                                    ? userInfo.userType !==
                                                        AppConstants
                                                            .USER_TYPES[0]
                                                        ? true
                                                        : false
                                                    : false
                                                : modPermission ===
                                                    VIEW_PERMISSION
                                                    ? true
                                                    : false
                                        }
                                        onClick={handleAddGuestList}
                                        color="primary">
                                        + Add Guest
                                    </Button>
                                </div>
                            </AppBar>
                        </Grid> 
                        <Grid sx={{ padding: 0 }}>
                            <Grid
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                }}>
                                <Typography
                                    component="div"
                                    sx={{
                                        color: '',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        padding: '.5rem',
                                        fontSize: 12,
                                    }}>
                                    <>
                                        <Box
                                            component="span"
                                            sx={{ mb: 0.5 }}>
                                            {/* <span
                                                dangerouslySetInnerHTML={{
                                                    __html: greenRoomGuestsText.get(),
                                                }}></span> */}
                                                <span>jacks</span>
                                        </Box>

                                        {isPreDraftPicture.get() === true ? <Box
                                            component="span"
                                            sx={{ mb: 0.5 }}>
                                            {`All  ${Helper.capitalize(Helper.numToWords(greenRoomGuest.get()))} (${greenRoomGuest.get()}) green room guests must have a credential. As such, please e-mail a picture (JPG or PNG format, under 2 MB) for each Green Room guest on a plain white background to Ivy Lin (`}
                                            <a href="#" target="_blank">
                                                ilin@nba.com
                                            </a>
                                            {`) ASAP.`}
                                        </Box> : null}
                                    </>
                                </Typography>
                            </Grid>
                        </Grid>

                        {state.guestList.attach(Downgraded).get().length >
                            0 && (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        backgroundColor: '#F1F6FF',
                                        flex: 1,
                                        marginTop: 2,
                                    }}>
                                    <Box
                                        flex={0.3}
                                        sx={{ justifyContent: 'center' }}>
                                        <Typography
                                            variant="h2"
                                            fontSize={12}
                                            fontWeight={500}
                                            paddingLeft={1}
                                            paddingTop={1}
                                            sx={{ paddingLeft: 5 }}
                                            color={'primary'}
                                            pb={1}>
                                            Name
                                        </Typography>
                                    </Box>

                                    <Box
                                        flex={0.3}
                                        maxLength={10}
                                        style={{ wordBreak: 'break-all' }}>
                                        <Typography
                                            variant="h2"
                                            fontSize={12}
                                            fontWeight={500}
                                            paddingLeft={1}
                                            paddingTop={1}
                                            sx={{ paddingLeft: 5 }}
                                            color={'primary'}
                                            pb={1}>
                                            Relation
                                        </Typography>
                                    </Box>
                                    {isPreDraftPicture.get() === true ? <Box
                                        flex={0.3}
                                        maxLength={10}
                                        style={{ wordBreak: 'break-all' }}>
                                        <Typography
                                            variant="h2"
                                            fontSize={12}
                                            fontWeight={500}
                                            paddingLeft={1}
                                            paddingTop={1}
                                            sx={{ paddingLeft: 5 }}
                                            color={'primary'}
                                            pb={1}>
                                            {`Pre-Draft Introduction (${preDraftPic.get()} guests in addition to draftee)`}
                                        </Typography>
                                    </Box> : null}
                                </Box>
                            )}

                        <Grid px={0}>
                            {state.guestList.attach(Downgraded).get()
                                .length > 0 &&
                                state.guestList
                                    .attach(Downgraded)
                                    .get()
                                    .map((field, idx) => {
                                        return (
                                            <Box
                                                key={idx}
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    flex: 1,
                                                    marginTop: 1,
                                                    backgroundColor:
                                                        '#f8f8f8',
                                                }}>
                                                <Box
                                                    flex={0.3}
                                                    sx={{
                                                        justifyContent:
                                                            'center',
                                                    }}>
                                                    <Typography
                                                        variant="h2"
                                                        fontSize={14}
                                                        fontWeight={400}
                                                        paddingLeft={1}
                                                        paddingTop={1}
                                                        sx={{
                                                            paddingLeft: 5,
                                                        }}
                                                        pb={1}>
                                                        {field.name}
                                                    </Typography>
                                                </Box>

                                                <Box
                                                    flex={0.7}
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection:
                                                            'row',
                                                        alignItems:
                                                            'center',
                                                    }}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            flex: 0.5,
                                                        }}>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={14}
                                                            fontWeight={400}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            pb={1}>
                                                            {
                                                                field.relationship
                                                            }
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            flex: 0.5,
                                                        }}>
                                                        {isPreDraftPicture.get() === true ? idx !== 0 ? (
                                                            <Checkbox
                                                                sx={{
                                                                    ml: 5,
                                                                }}
                                                                disabled={
                                                                    field.preDraftPicture
                                                                        ? false
                                                                        : state.guestList
                                                                            .attach(
                                                                                Downgraded
                                                                            )
                                                                            .get()
                                                                            .filter(
                                                                                (
                                                                                    x
                                                                                ) =>
                                                                                    x.preDraftPicture ===
                                                                                    true
                                                                            )
                                                                            .length ===
                                                                            preDraftPic.get() ||
                                                                            props.modPermission ===
                                                                            VIEW_PERMISSION
                                                                            ? true
                                                                            : false
                                                                }
                                                                checked={
                                                                    field.preDraftPicture
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) =>
                                                                    handlePreDraftPicChange(
                                                                        e,
                                                                        idx
                                                                    )
                                                                }
                                                            />
                                                        ) : null : null}
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            flex: 0.05,
                                                        }}>
                                                        {idx !== 0 &&
                                                            props.modPermission !==
                                                            VIEW_PERMISSION ? (
                                                            <Box
                                                                component="img"
                                                                className={
                                                                    classes.sedanBlack
                                                                }
                                                                disabled={
                                                                    true
                                                                }
                                                                alt="logo."
                                                                src={
                                                                    IconPencil
                                                                }
                                                                onClick={() =>
                                                                    handleGuestEditData(
                                                                        field.name,
                                                                        field.relationship,
                                                                        idx
                                                                    )
                                                                }
                                                            />
                                                        ) : (
                                                            <Box></Box>
                                                        )}
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            flex: 0.05,
                                                        }}>
                                                        {idx !== 0 &&
                                                            props.modPermission !==
                                                            VIEW_PERMISSION ? (
                                                            <Box
                                                                component="img"
                                                                className={
                                                                    classes.sedanBlack
                                                                }
                                                                alt="logo."
                                                                src={trash}
                                                                onClick={() =>
                                                                    handleRemoveGuest(
                                                                        idx
                                                                    )
                                                                }
                                                            />
                                                        ) : (
                                                            <Box></Box>
                                                        )}
                                                    </Box>
                                                </Box>
                                            </Box>
                                        );
                                    })}
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            {openGuestDialog.get() && (
                <AddGuest
                    open={openGuestDialog.get()}
                    title={
                        stateGuestObj.get() ? 'Update Guest' : 'Add Guest'
                    }
                    handleClose={handleAddGuestClose}
                    handleAction={handleGuestAction}
                    data={stateGuestObj.get()}
                />
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
        </Box>
    )
}
export default {
    routeProps: {
        path: [RouteConstants.CREATE_GREEN_ROOM, RouteConstants.EDIT_GREEN_ROOM],
        component: CreateGreenRoom,
    },
    name: 'CreateGreenRoom',
};